/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';

import './fake.scss';
import './startingPoints.scss';

const TITLE_WIDTH = 350;
const FIELD_WIDTH = 140;
const TEXT_HEIGHT = 15;
const FIELD_HEIGHT = 40;

const FAKE_STYLES = {
	pageTitle: {
		width: `${TITLE_WIDTH}px`,
		height: `${TEXT_HEIGHT+10}px`
	},
	text: {
		width: `${TITLE_WIDTH+80}px`,
		height: `${TEXT_HEIGHT}px`,
		marginBottom: '30px'
	},
	focusFieldTitle: {
		width: `${FIELD_WIDTH+40}px`,
		height: `${TEXT_HEIGHT}px`,
		marginTop: '0px',
		marginBottom: '0px'
	},
	fieldTextInput: {
		width: `${FIELD_WIDTH+80}px`,
		height: `${FIELD_HEIGHT}px`,
		marginTop: '0px',
		marginRight: '0px'
	},
	field: {
		width: `${FIELD_WIDTH}px`,
		height: `${FIELD_HEIGHT}px`,
		marginTop: '0px',
		marginRight: '0px'
	}
};

class FakeFields extends Component {

	render() {
		return (
			<div className="starting-points-fields">
				<div className="starting-points-header">
					<div className='fake' style={FAKE_STYLES.pageTitle}/>
					<div className='fake' style={FAKE_STYLES.text}/>
				</div>
				<div className='focusField'>
					<div className='fake' style={FAKE_STYLES.focusFieldTitle}/>
				</div>
				<div className="fields-control">
					<div className='fake' style={FAKE_STYLES.fieldTextInput}/>
					<div className='fake' style={FAKE_STYLES.field}/>
					<div className='fake' style={FAKE_STYLES.field}/>
					<div className='fake' style={FAKE_STYLES.field}/>
					<div className='fake' style={FAKE_STYLES.field}/>
					<div className='fake' style={FAKE_STYLES.field}/>
				</div>
			</div>
		);
	}

}

export default FakeFields;



// WEBPACK FOOTER //
// ./src/js/components/startingPoints/FakeFields.js